import { render } from "./causes.vue?vue&type=template&id=14a7fb47"
const script = {}

import "./causes.vue?vue&type=style&index=0&id=14a7fb47&lang=css"

import exportComponent from "X:\\Proyecto\\riego-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__